import { get } from 'lodash';

import { hideLoading, showLoading } from 'redux-store/reducers/loading-reducer';
import { danger, success } from 'redux-store/reducers/common-reducer';

import { API, patch } from 'utils/api';
import { t } from 'utils/language';

const { NEW_USERS } = API.END_POINTS.API;

const COMMON_ERRORS = {
  'model.error.validate': t('change_password_incorrect_password')
};

export function changePassword(userId, payload) {
  const url = `${NEW_USERS}/${userId}`;
  const headers = {
    'X-Password-Op-Kind': 'change'
  };

  return dispatch => {
    dispatch(showLoading(url));
    return patch(url, { data: payload, headers })
      .then(() => {
        dispatch(hideLoading(url));
        dispatch(success(t('change_password_success')));
      })
      .catch((error) => {
        const errorMessage = COMMON_ERRORS[get(error, 'response.data.code')]
          || t('change_password_unknown_error');
        dispatch(danger(errorMessage));
        dispatch(hideLoading(url));
        throw error;
      });
  };
}
